import { Pipe, PipeTransform } from '@angular/core';

import { isPopupVisible } from '../constants/constants';

@Pipe({ name: 'isPopupVisible' })
export class IsPopupVisiblePipe implements PipeTransform {
  transform(hour: any, stationId: any, popupVisible: any) {
    return isPopupVisible(hour, stationId, popupVisible);
  }
}
